<template>
  <NuxtLayout name="default">
    <template #header>
      <SiteHeader>
        <template #hero>
          <ContentContainer>
            <section
              class="z-20 grid grid-cols-1 content-center gap-9 lg:gap-14 py-14"
            >
              <slot name="pageHero" />
            </section>
          </ContentContainer>
        </template>
      </SiteHeader>
    </template>

    <template #content>
      <main class="relative bg-white z-20">
        <LazyDrupalTabs v-if="page.local_tasks" :tabs="page.local_tasks" />
        <slot name="components" />
      </main>
    </template>
  </NuxtLayout>
</template>

<script setup lang="ts">
const { fetchPage } = useDrupalCe();

const page = await fetchPage(useRoute().path, { query: useRoute().query });

defineSlots<{
  components?(): any;
  pageHero?(): any;
}>();

// default props passed in, defined to stop warnings in console
defineProps<{
  body?: any;
  created?: any;
  layoutType?: string;
  title?: string;
  uid?: string | object;
}>();
</script>
